import { create } from 'zustand';

export type TaskBottomBarPayload = {
  isCompleted: boolean;
  isRunning: boolean;
  plannedStr: string;
  spentStr: string;
  remainingStr: string;
  remainingLabel: string;
  isOverdue: boolean;
  canDeleteThisTask: boolean;
  plannedSeconds: number;

  onStartPause: () => void;
  onFinish: () => void;
  onJump: () => void;
  onDelete: () => void;
  onClose: () => void;
  onSavePlan: (nextSeconds: number) => Promise<void> | void;

  jumpPending: boolean;
  jumpDisabled: boolean;
};

type TaskBottomBarStore = {
  isVisible: boolean;
  payload: TaskBottomBarPayload | null;
  show: (payload: TaskBottomBarPayload) => void;
  hide: () => void;
};

export const useTaskBottomBarStore = create<TaskBottomBarStore>((set) => ({
  isVisible: false,
  payload: null,

  show: (payload) => set({ isVisible: true, payload }),
  hide: () => set({ isVisible: false, payload: null }),
}));
